//   images
import video1 from "../../Img/video/vid3.mp4";
import logo2 from "../../Img/logo-name.png";
import logo from "../../Img/logo.png";
// css
import "./Section1.css";

//comp
import Grid from "../Grid/Grid.js";
import Sponser from "../Sponser/Sponser.js";
import Sec22 from "../Sec22/Sec22.js";

const links = [
  { name: "Open roles", href: "#" },
  { name: "Internship program", href: "#" },
  { name: "Our values", href: "#" },
  { name: "Meet our leadership", href: "#" },
];
const stats = [
  { name: "Offices worldwide", value: "12" },
  { name: "Full-time colleagues", value: "300+" },
  { name: "Hours per week", value: "40" },
  { name: "Paid time off", value: "Unlimited" },
];

export default function Example() {
  return (
    <div className="relative isolate overflow-hidden  Section1">
      <div className="d-loading">
        <img class="loading" src={logo} alt="" />
      </div>

      <div
        className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl "
        aria-hidden="true"
      >
        <div
          className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#449e6e] to-[#3ba0a0]  opacity-2"
          style={{
            clipPath:
              "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
          }}
        />
      </div>
      <div
        className=" absolute -tob-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu"
        aria-hidden="true"
      >
        <div
          className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#46ffff] to-[#449e6e] opacity-2"
          style={{
            clipPath:
              "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
          }}
        />
      </div>

      <div class="w-full lg:px-8 p-5 flex flex-col justify-center items-center backdrop-blur-3xl h-full inset-0 bg-white/50">
        <div class="mx-auto max-w-5xl lg:mx-0 flex flex-col justify-center items-center w-full pt-40 pb-20 sm:pb-0 lg:pt-0 lg:h-screen">
          <img
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
            src={logo2}
            alt=""
            className="w-1/2 pb-6 md:w-1/2 lg:w-1/4 img-logo"
          />

          <p className="mx-auto max-w-6xl font-display text-5xl font-medium tracking-tight text-center text-slate-900 sm:text-7xl">
            Join <span className="hidden lg:inline-block mx-auto max-w-6xl font-display text-5xl font-medium tracking-tight text-center text-slate-900 sm:text-7xl  ">us</span> to reduce {" "}
            <span class="relative whitespace-nowrap text-teal-500">
              <svg
                aria-hidden="true"
                viewBox="0 0 418 42"
                class="absolute left-0 top-2/3 h-[0.58em] w-full fill-teal-500/70"
                preserveAspectRatio="none"
              >
                <path d="M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.78 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.54-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.81 23.239-7.825 27.934-10.149 28.304-14.005.417-4.348-3.529-6-16.878-7.066Z"></path>
              </svg>
              <span class="relative font-medium">food waste</span>
            </span>{" "}
            and start saving today
          </p>

          <p className="mx-auto mt-6 max-w-2xl text-lg text-center tracking-tight text-slate-800">
            Food waste is a major global challenge, causing negative
            environmental, economic, and social impacts. The 'Naturix' app is
            here to help reduce it.
          </p>

          <div class="mt-10 flex justify-center gap-x-6">
            <a
              class="group text-center inline-flex items-center justify-center rounded-full py-2 px-4 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-slate-900 text-white hover:bg-slate-700 hover:text-slate-100 active:bg-slate-800 active:text-slate-300 focus-visible:outline-slate-900"
              variant="solid"
              color="slate"
              href="http://localhost:3002/"
            >
              Join To Community
            </a>
            <a
              class="group inline-flex ring-1 items-center justify-center rounded-full py-2 px-4 text-sm focus:outline-none ring-slate-400 text-slate-700 hover:text-slate-900 hover:ring-slate-500 active:bg-slate-100 active:text-slate-600 focus-visible:outline-blue-600 focus-visible:ring-slate-300"
              variant="outline"
              target="_blank"
              color="slate"
              href="https://youtu.be/kkURdA32giI?si=YUhb7C7vy8KEzM8Z"
              // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> YOUTUBE >>>>>>>
            >
              <svg
                aria-hidden="true"
                class="h-3 w-3 flex-none fill-blue-600 group-active:fill-current"
              >
                <path d="m9.997 6.91-7.583 3.447A1 1 0 0 1 1 9.447V2.553a1 1 0 0 1 1.414-.91L9.997 5.09c.782.355.782 1.465 0 1.82Z"></path>
              </svg>
              <span class="ml-3 text-center">Watch video</span>
            </a>
          </div>
          <Grid />
        </div>
        {/* <Sponser/> */}

        <Sec22 />
      </div>
    </div>
  );
}
